import { useState } from "react";
import { Box, Paper } from "@mui/material";
import Login from "./Login";
import Register from "./Register";
import LoadingOverlay from "../../../../components/Shared/LoadingOverlay";
import useScreenSize from "../../../../hooks/useScreenSize";

import logoRed from '../../../../assets/logo-red.png';
import cover from '../../../../assets/cover.png';

const LandingPage = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [registerSuccess, setRegisterSuccess] = useState(false);

    const screenSize = useScreenSize();

    return (
        <Box display="flex" width="100%" height="100vh">
            <LoadingOverlay open={isLoading} />
            <Box flex={screenSize.width < 900 ? "0 0 0" : "0 0 45%"} overflow="hidden" position="relative">
                <img 
                    src={cover}
                    alt="cover-image"
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                        filter: 'blur(4px)'
                    }}
                />
            </Box>
            <Paper 
                variant="outlined"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: screenSize.width < 900 ? "100%" : "50%",
                    gap: 3,
                    padding: 5,
                    margin: 5,
                    overflow: 'auto'
                }}
            >
                <img src={logoRed} alt="statrat-logo" height="58px" width="118.5px" />
                {isLogin ? (
                    <Login
                        setIsLogin={setIsLogin}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        registerSuccess={registerSuccess}
                        setRegisterSuccess={setRegisterSuccess}
                    />
                ) : (
                    <Register
                        setIsLogin={setIsLogin}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        setRegisterSuccess={setRegisterSuccess}
                    />
                )}
            </Paper>
        </Box>
    )
}

export default LandingPage;
